module.exports = "/_next/static/images/140d056513cd3add42b7685bea7d5f4f-pay-xs.png";